import { type schemaType } from '~~/shared/api/rurality/v3/bookmarks/save/schema'
import { type paramsType } from '~~/shared/api/rurality/v3/bookmarks/save/paramsSchema'

export type returnType = ApiServerResponse<schemaType>

export const serverFetch = async (params: paramsType): Promise<returnType> => {
  const runtimeConfig = useRuntimeConfig()
  const url = `${runtimeConfig.public.NUXT_API_CONTENT_ROOT_URL}/rurality/v3/bookmarks/save`

  const { data } = await useFetch(url, {
    body: {
      ...params,
    },
    method: 'POST',
    key: url,
  })

  return data.value as returnType
}

export const browserFetch = async (params: paramsType): Promise<returnType> => {
  const runtimeConfig = useRuntimeConfig()
  const url = `${runtimeConfig.public.NUXT_API_CONTENT_ROOT_URL}/rurality/v3/bookmarks/save`

  const data = await $fetch(url, {
    body: {
      ...params,
    },
    method: 'POST',
  })

  return data as returnType
}
